//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export interface ITwitterScheduleFailureContext {
  errorType: ScheduledTweetValidationErrorType;
}

export enum ScheduledTweetValidationErrorType {
  MissingMediaAndText = 'MissingMediaAndText',
  TooManyImages = 'TooManyImages',
  MismatchedMediaType = 'MismatchedMediaType',
  ImageFileSize = 'ImageFileSize',
  TooManyGifs = 'TooManyGifs',
  GifFileSize = 'GifFileSize',
  TooManyVideos = 'TooManyVideos',
  VideoFileSize = 'VideoFileSize',
  VideoAspectRatio = 'VideoAspectRatio',
  VideoDuration = 'VideoDuration',
}
